import PropTypes from 'prop-types';

import SimilarStock from 'components/similar_stock/';
import useProductShowStore from 'stores/product_show_store/useProductShowStore';

import DeliveryInformation from 'components/product_show/add_to_basket/delivery_information';

const SecondaryProductActions = ({
  similarStockUrl,
  deliveryStock,
  vatExclusive,
  stepId,
  isCollectionOnly,
}) => {
  const { selectedStore, locationId } = useProductShowStore();

  return (
    <div className="secondary-product-actions fl">
      {!isCollectionOnly && deliveryStock > 0 && (
        <div
          className={`secondary-product-actions__delivery-information fl-grow-1 fb-0 ${
            locationId ? 'jc-c' : 'jc-fs'
          }`}>
          <DeliveryInformation />
        </div>
      )}
      {locationId && (
        <div className="secondary-product-actions__similar-stock fl-grow-1 fb-0">
          <SimilarStock
            v2Product
            isProductDetail
            productId={stepId}
            currentStoreName={selectedStore}
            currentStoreLocationId={locationId}
            similarStockUrl={similarStockUrl}
            vatExclusive={vatExclusive}
          />
        </div>
      )}
    </div>
  );
};

SecondaryProductActions.propTypes = {
  similarStockUrl: PropTypes.string,
  vatExclusive: PropTypes.bool,
  stepId: PropTypes.string,
};

export default SecondaryProductActions;
